import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8 1.333A6.667 6.667 0 1 0 10.55 14.16c1.218-.505 2.992-2.455 2.992-2.455A6.667 6.667 0 0 0 8 1.334M4.862 7.53a.67.67 0 0 1 .471-.196h5.334a.667.667 0 1 1 0 1.334H5.333a.667.667 0 0 1-.471-1.138",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })